module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["root"]
  }, _vm._l((_vm.cItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: ["simple-flow-item-wrapper"],
      staticStyle: {
        width: "750px"
      },
      attrs: {
        "accessible": true,
        "ariaLabel": ((item.title) + "," + (item.desc ? item.desc : '') + "," + (item.date ? item.date : '') + "," + (item.highlight ? '已完成' : '等待完成'))
      }
    }, [(_vm.leftContent) ? _c('div', {
      staticClass: ["left-content-wrap"],
      style: _vm.leftContentStyle
    }, [_vm._t("leftContent", [(item.leftContentDate) ? _c('text', {
      staticClass: ["left-text-date"],
      class: item.__titleTextClass__,
      style: item.__titleStyle__
    }, [_vm._v(_vm._s(item.leftContentDate))]) : _vm._e()], {
      item: item
    })], 2) : _vm._e(), _c('div', {
      ref: "rightContent",
      refInFor: true,
      staticStyle: {
        flex: "1"
      }
    }, [_c('div', {
      staticClass: ["title", "flex-row"]
    }, [_c('div', {
      staticClass: ["line"],
      class: item.__titleLineClass__,
      style: item.__lineStyle__
    }), _c('div', {
      staticClass: ["point"],
      class: item.__pointClass__,
      style: item.__pointStyle__
    }, [(item.highlight && !_vm._isColmo) ? _c('div', {
      staticClass: ["highlightInner"],
      style: {
        backgroundColor: item.__pointStyle__.innerBackgroundColor ?
          item.__pointStyle__.innerBackgroundColor :
          (_vm._isDiablo ? '#0490D3' : '#00a4f2')
      }
    }) : _vm._e()]), _c('text', {
      staticClass: ["text-title", "full-rest"],
      class: item.__titleTextClass__,
      style: item.__titleStyle__
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: ["content", "flex-row"],
      class: item.__contentClass__
    }, [_c('div', {
      staticClass: ["line"],
      class: item.__contentLineClass__,
      style: item.__lineStyle__
    }), _c('div', {
      staticClass: ["full-rest"]
    }, [(item.desc) ? _c('text', {
      staticClass: ["text-desc"],
      style: {
        width: _vm.rightContentWidth ? _vm.rightContentWidth + 'px' : 'auto'
      }
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e(), (item.date) ? _c('text', {
      staticClass: ["text-date"]
    }, [_vm._v(_vm._s(item.date))]) : _vm._e()])])])])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-bc5f15f4!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-simple-flow/index.vue
// module id = 660
// module chunks = 0 1